import React from 'react';
import { Quote } from 'lucide-react';


export function Testimonials({t}) {
  
const testimonials = [
  {
    name: t.firstTestimonialName,
    image: t.firstTestimonialImage,
    text: t.firstTestimonialText,
  },
  {
    name: t.secondTestimonialName,
    image: t.secondTestimonialImage,
    text: t.secondTestimonialText,
  },
  {
    name: t.thirdTestimonialName,
    image: t.thirdTestimonialImage,
    text: t.thirdTestimonialText,
  },
  {
    name: t.fourthTestimonialName,
    image: t.fourthTestimonialImage,
    text: t.fourthTestimonialText,
  },
];
  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-5xl font-bold text-[--c-dark] mb-4">{t.testimonialsTitle}</h2>
          <div className="w-32 h-1 bg-[--c-accent] mx-auto"></div>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-[--c-verylight] rounded-lg shadow-lg p-6 transform transition duration-300 hover:-translate-y-1 hover:shadow-xl"
            >
              <div className="relative">
                <Quote className="absolute -top-2 -left-2 w-8 h-8 text-[--c-dark] opacity-50" />
                <img
                  src={`/${testimonial.image}.jpg`}
                  alt={testimonial.name}
                  className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 rounded-full mx-auto mb-4 object-cover border-4 border-[--c-main] shadow"
                />
              </div>
              <div className="text-center">
                <h3 className="text-m sm:text-2xl md:text-3xl font-semibold text-[--c-dark] mb-2">{testimonial.name}</h3>
                <p className="text-xs italic text-lg sm:text-xl md:text-2xl text-[--c-main]">{testimonial.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
